import {Button, Card, CloseButton, Col, OverlayTrigger, Row, Tooltip} from "react-bootstrap";
import {capitalizeWords, snakeCaseToNormalString} from "../../General/SharedMethods";
import {TbCopy} from "react-icons/tb";
import React, {useRef, useState} from "react";

export default function CredentialsProperties({properties, onClose, typeName, copyTextToClipboard}) {

    const [showToolTip, setShowToolTip] = useState(false);
    const ref = useRef(null);
    return (
        <Card bsPrefix='squareCard'>
            <Card.Header style={{height: '32.094px', backgroundColor: 'white'}} className="d-flex align-items-center">
                <div className="flex-grow-1"></div>
                <Card.Title style={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    paddingTop: '20px'
                }}>{capitalizeWords(typeName)} Properties</Card.Title>
                <div className="flex-grow-1 d-flex justify-content-end mb-1"><CloseButton onClick={onClose}
                                                                                          aria-label="Close"/></div>
            </Card.Header>
            <Card.Body>
                {properties.map(({key, value}) => (

                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <div className={'d-inline-block mr-2'}>
                            {snakeCaseToNormalString(key)}:
                        </div>
                        {showToolTip ?
                            <OverlayTrigger placement="right" overlay={<Tooltip> {value}</Tooltip>}>
                                <div ref={ref} style={{overflow: 'hidden', textOverflow: 'ellipsis'}}
                                     className={'d-inline-block'}>
                                    {value}
                                </div>
                            </OverlayTrigger>
                            :
                            <div ref={ref} style={{overflow: 'hidden', textOverflow: 'ellipsis'}}
                                 className={'d-inline-block'}>
                                {value}
                            </div>
                        }
                        <div className={'d-inline-block'}>
                            <Button className='p-0 ml-2 mr-2' variant={'link'} style={{color: 'black'}}>
                                <TbCopy onClick={() => copyTextToClipboard(value)} size={25}/>
                            </Button>
                        </div>
                    </div>
                ))}
            </Card.Body>
        </Card>
    );
}
